import React from 'react';
import { useHistory } from 'react-router-dom';
import { useBreadcrumb } from '../context/BreadcrumbContext';

export default function Breadcrumb() {
    const trail = useBreadcrumb();
    const history = useHistory();

    // Só exibe quando há mais de 1 página no histórico
    if (!trail || trail.length <= 1) return null;

    return (
        <nav aria-label="breadcrumb" style={{ padding: '4px 16px 0 16px' }}>
            <ol className="breadcrumb" style={{ marginBottom: '0', background: 'transparent', padding: '4px 0', fontSize: '0.85rem' }}>
                {trail.map((item, idx) => {
                    const isLast = idx === trail.length - 1;
                    return (
                        <li
                            key={idx}
                            className={`breadcrumb-item${isLast ? ' active' : ''}`}
                            aria-current={isLast ? 'page' : undefined}
                        >
                            {isLast ? (
                                <span style={{ color: '#6c757d' }}>{item.label}</span>
                            ) : (
                                <a
                                    href={item.path}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        history.push(item.path);
                                    }}
                                    style={{ color: '#435ebe', textDecoration: 'none' }}
                                >
                                    {item.label}
                                </a>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}
